
const routes = [
  {
    path: '/',
    name: 'dashboard',
    component: () => import(/* webpackChunkName: "Blank" */ '@/view/pages/Dashboard/Index.vue'),
  },
  // User Management
  {
    path: '/admin-user-management',
    name: 'admin-user-management',
    component: () => import(/* webpackChunkName: "Blank" */ '@/view/pages/UserManagement/ListUser.vue'),
  },
  {
    path: '/admin-user-management/view',
    name: 'admin-user-management-view',
    component: () => import(/* webpackChunkName: "Blank" */ '@/view/pages/UserManagement/ViewUser.vue'),
  },
  {
    path: '/admin-user-management/create',
    name: 'admin-user-management-create',
    component: () => import(/* webpackChunkName: "Blank" */ '@/view/pages/UserManagement/CreateUser.vue'),
  },
  {
    path: '/admin-user-management/update',
    name: 'admin-user-management-update',
    component: () => import(/* webpackChunkName: "Blank" */ '@/view/pages/UserManagement/UpdateUser.vue'),
  },
  // Role
  {
    path: '/role-management',
    name: 'role-management',
    component: () => import(/* webpackChunkName: "Blank" */ '@/view/pages/UserManagement/RolePermission/ListRole.vue'),
  },
  {
    path: '/role-management/create',
    name: 'role-management-create',
    component: () => import(/* webpackChunkName: "Blank" */ '@/view/pages/UserManagement/RolePermission/CreateRole.vue'),
  },
  {
    path: '/role-management/update',
    name: 'role-management-update',
    component: () => import(/* webpackChunkName: "Blank" */ '@/view/pages/UserManagement/RolePermission/UpdateRole.vue'),
  },
  //PSGC
  {
    path: '/region',
    name: 'psgc-region',
    component: () => import(/* webpackChunkName: "Blank" */ '@/view/pages/PSGC/Region/ListRegion.vue'),
  },
  {
    path: '/region/view',
    name: 'psgc-region-view',
    component: () => import(/* webpackChunkName: "Blank" */ '@/view/pages/PSGC/Region/ViewOneRegion.vue'),
  },
  {
    path: '/province',
    name: 'psgc-province',
    component: () => import(/* webpackChunkName: "Blank" */ '@/view/pages/PSGC/Province/ListProvince.vue'),
  },
  {
    path: '/province/view',
    name: 'psgc-province-view',
    component: () => import(/* webpackChunkName: "Blank" */ '@/view/pages/PSGC/Province/ViewOneProvince.vue'),
  },
  {
    path: '/city',
    name: 'psgc-city',
    component: () => import(/* webpackChunkName: "Blank" */ '@/view/pages/PSGC/City/ListCity.vue'),
  },
  {
    path: '/city/view',
    name: 'psgc-city-view',
    component: () => import(/* webpackChunkName: "Blank" */ '@/view/pages/PSGC/City/ViewOneCity.vue'),
  },
  {
    path: '/barangay',
    name: 'psgc-barangay',
    component: () => import(/* webpackChunkName: "Blank" */ '@/view/pages/PSGC/Barangay/ListBarangay.vue'),
  },
  //Facilities
  {
    path: '/barangay-health-station',
    name: 'barangay-health-station',
    component: () => import(/* webpackChunkName: "Blank" */ '@/view/pages/Facilities/BHS/BrgyHealthStation.vue'),
  },
  {
    path: '/barangay-health-station/view-one',
    name: 'barangay-health-station-view-one',
    component: () => import(/* webpackChunkName: "Blank" */ '@/view/pages/Facilities/BHS/ViewOneBHS.vue'),
  },
  // {
  //   path: '/barangay-health-station/add-facility',
  //   name: 'add-bhs-facility',
  //   component: () => import(/* webpackChunkName: "Blank" */ '@/view/pages/Facilities/BHS/SubPages/AddBHSFacility.vue'),
  // },
  //Vaccines
  {
    path: '/vaccines',
    name: 'vaccines',
    component: () => import(/* webpackChunkName: "Blank" */ '@/view/pages/Vaccines/VaccineList.vue'),
  },
  {
    path: '/vaccines/view-one',
    name: 'vaccines-view-one',
    component: () => import(/* webpackChunkName: "Blank" */ '@/view/pages/Vaccines/VaccineViewOne.vue'),
  },
  {
    path: '/antigens',
    name: 'antigens',
    component: () => import(/* webpackChunkName: "Blank" */ '@/view/pages/Antigen/AntigenList.vue'),
  },
  {
    path: '/antigens/view-one',
    name: 'antigen-view-one',
    component: () => import(/* webpackChunkName: "Blank" */ '@/view/pages/Antigen/ViewOneAntigenList.vue'),
  },
  // TCL
  {
    path: '/tcl',
    name: 'tcl',
    component: () => import(/* webpackChunkName: "Blank" */ '@/view/pages/TCL/ListTCL.vue'),
  },
  {
    path: '/tcl/life-stage',
    name: 'tcl-life-stage',
    component: () => import(/* webpackChunkName: "Blank" */ '@/view/pages/TCL/LifeStageTCL.vue'),
  },
  {
    path: '/tcl/life-stage/antigen-nutrition',
    name: 'tcl-life-stage-antigen-nutrition',
    component: () => import(/* webpackChunkName: "Blank" */ '@/view/pages/TCL/AntigenNutritionTCL.vue'),
  },
  {
    path: '/tcl/life-stage/antigen-nutrition/antigen',
    name: 'tcl-life-stage-antigen-doze',
    component: () => import(/* webpackChunkName: "Blank" */ '@/view/pages/TCL/AntigenDoze.vue'),
  },
  {
    path: '/tcl/life-stage/antigen-nutrition/nutrition',
    name: 'tcl-life-stage-nutrition-doze',
    component: () => import(/* webpackChunkName: "Blank" */ '@/view/pages/TCL/NutritionDose.vue'),
  },
  // User Profile
  {
    path: '/profile',
    name: 'profile',
    component: () => import(/* webpackChunkName: "Blank" */ '@/view/pages/Profile/UserProfile.vue'),
  },
  // RHU
  {
    path: '/rural-health-unit',
    name: 'rural-health-unit',
    component: () => import(/* webpackChunkName: "Blank" */ '@/view/pages/Facilities/RHU/RHUList.vue'),
  },
  {
    path: '/rural-health-unit/view-one',
    name: 'rural-health-unit-view-one',
    component: () => import(/* webpackChunkName: "Blank" */ '@/view/pages/Facilities/RHU/RHUViewOne.vue'),
  },
  // CHO city-health-office
  {
    path: '/city-health-office',
    name: 'city-health-office',
    component: () => import(/* webpackChunkName: "Blank" */ '@/view/pages/Facilities/CHO/CHOList.vue'),
  },
  // Health Facilities
  {
    path: '/facilities',
    name: 'health-facilities',
    component: () => import(/* webpackChunkName: "Blank" */ '@/view/pages/Facilities/HealthFacility/ListFacility.vue'),
  },
  {
    path: '/facilities/create',
    name: 'create-health-facilities',
    component: () => import(/* webpackChunkName: "Blank" */ '@/view/pages/Facilities/HealthFacility/AddFacility.vue'),
  },
  {
    path: '/facilities/update',
    name: 'update-health-facilities',
    component: () => import(/* webpackChunkName: "Blank" */ '@/view/pages/Facilities/HealthFacility/EditFacility.vue'),
  },
  {
    path: '/facilities/view-one',
    name: 'view-one-health-facilities',
    component: () => import(/* webpackChunkName: "Blank" */ '@/view/pages/Facilities/HealthFacility/ViewOne/ListFacility.vue'),
  },
  {
    path: '/facilities/view-one/user',
    name: 'facility-user',
    component: () => import(/* webpackChunkName: "Blank" */ '@/view/pages/Facilities/HealthFacility/ViewOne/Users/ViewUser.vue'),
  },
  {
    path: '/facilities/view-one/user/create',
    name: 'facility-user-create',
    component: () => import(/* webpackChunkName: "Blank" */ '@/view/pages/Facilities/HealthFacility/ViewOne/Users/AddUser.vue'),
  },
  {
    path: '/facilities/view-one/user/update',
    name: 'facility-user-update',
    component: () => import(/* webpackChunkName: "Blank" */ '@/view/pages/Facilities/HealthFacility/ViewOne/Users/EditUser.vue'),
  },
  {
    path: '/target-management',
    name: 'target-management',
    component: () => import(/* webpackChunkName: "Blank" */ '@/view/pages/Target/ListTarget.vue'),
  }

];

export default routes;
